import { KEYS, localStorageService } from 'utils/localStorage'
import { PATHS } from 'utils/paths'
import { isPublicAppRoute } from 'utils/publicAppRoutes'

export function clearSessionAndRedirectToLogin(): void {
  localStorageService.remove(KEYS.token)
  if (window.location.pathname !== PATHS.login) {
    window.location.href = PATHS.login
  }
}

/** Redirect to login on 401 only inside the authenticated app (not previews / public package links). */
export function redirectToLoginIfUnauthorized(statusCode?: number): void {
  if (statusCode !== 401) {
    return
  }

  if (isPublicAppRoute(window.location.pathname)) {
    return
  }

  if (!localStorageService.get(KEYS.token)) {
    return
  }
  clearSessionAndRedirectToLogin()
}
